import { Injectable } from '@angular/core';
import { SubscriptionsValuesService } from '../../../../common/values/subscriptions.values.service';
import { ValuesService } from '../../../../common/values/values.service';
import { CheckoutSdkService } from '../../core/checkout-sdk.service';

@Injectable({
    providedIn: 'root'
})
export class ICheckoutSdkService {

    constructor(
        public readonly checkoutSdkService: CheckoutSdkService,
        public readonly subscriptionsValuesService: SubscriptionsValuesService,
        public readonly valuesService: ValuesService
    ) { }

    createBillingDetailsInterface() {
        const billingDetailsInterface = {
            name: `${this.checkoutSdkService.getBillingDetailsFirstName()} ${this.checkoutSdkService.getBillingDetailsLastName()}`,
            address: this.checkoutSdkService.getBillingDetailsAddress(),
            type: this.checkoutSdkService.getBillingDetailsVatNo() && this.checkoutSdkService.getBillingDetailsCompanyName()
                    ? this.subscriptionsValuesService.billingAccountType.company
                    : this.subscriptionsValuesService.billingAccountType.personal,
            country_name: this.computeCountryName()
        };
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        billingDetails.interface = billingDetailsInterface;
    }

    computeCountryName() {
        const countryCode = this.checkoutSdkService.getBillingDetailsCountryCode();
        for (const country of this.valuesService.zuoraCountriesISO) {
            if (country.key === countryCode) {
                return country.value;
            }
        }
        return "";
    }

    getBillingDetailsName() {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.name;
    }

    getBillingDetailsAddress() {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.address;
    }

    getBillingDetailsCountryName() {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.country_name;
    }

    getBillingDetailsType() {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.type;
    }
}